import { Box, Stack, Typography } from "@mui/joy";
import { useTranslation } from "react-i18next";
export default function Positioning() {
  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });

  return (
    <Box
      sx={{
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      {[
        ["", "디스턴싱", "상담 치료", "약물 치료"],
        ["예약 없는 이용", "O", "X", "X"],
        ["데일리 관리", "O", "X", "X"],
        ["종결 이후 관리", "O", "X", "X"],
        ["최신 인지과학 기반", "O", "-", "X"],
        ["일상에서의 실습", "O", "-", "X"],
        ["유연한 개인 대응", "O", "O", "X"],
        ["약물 미사용", "O", "O", "X"],
        ["비밀 보장", "O", "O", "O"],
      ].map((lines, colIndex) => (
        <Stack key={`positioning_${colIndex}`} direction={"row"}>
          {lines.map((line, rowIndex) => (
            <Stack
              key={`${line}_${colIndex}_${rowIndex}`}
              justifyContent={"center"}
              alignItems={rowIndex === 0 ? "start" : "center"}
              sx={{
                backgroundColor:
                  colIndex === 0 && rowIndex === 1
                    ? "primary.solid"
                    : colIndex === 0
                    ? "primary.deactivated"
                    : rowIndex === 1
                    ? "primary.soft"
                    : "card.background",
                px: { xs: "10px", sm: "20px" },
                minWidth: rowIndex === 0 ? "40%" : "20%",
                width: rowIndex === 0 ? "40%" : "20%",
                py: "9px",
                whiteSpace: rowIndex === 0 ? "inherit" : "nowrap",
                wordBreak: "keep-all",
              }}
            >
              <Box
                sx={{
                  fontWeight: colIndex === 0 ? 600 : 500,
                  color:
                    colIndex === 0 && rowIndex === 1
                      ? "text.negative"
                      : rowIndex === 1 && colIndex > 0
                      ? "primary.solid"
                      : "text.positive",
                  opacity:
                    colIndex > 0 && rowIndex > 1
                      ? line === "X"
                        ? 0.3
                        : 0.5
                      : 1,
                  display: "flex",
                }}
              >
                {line === "X" ? (
                  <span className="material-symbols-rounded">close</span>
                ) : line === "O" ? (
                  <span className="material-symbols-rounded">done</span>
                ) : line === "-" ? (
                  <span className="material-symbols-rounded">remove</span>
                ) : (
                  <Typography
                    sx={{
                      color:
                        colIndex === 0 && rowIndex === 1
                          ? "text.negative"
                          : rowIndex === 1 && colIndex > 0
                          ? "primary.solid"
                          : "text.positive",
                    }}
                    level={"body-xs"}
                    fontWeight={colIndex === 0 ? "600" : "500"}
                  >
                    {!["", "X", "O", "-"].includes(line)
                      ? t_payment(line)
                      : line}
                  </Typography>
                )}
              </Box>
            </Stack>
          ))}
        </Stack>
      ))}
    </Box>
  );
}
